<template src="./incomingMessages.template.html"></template>

<script>
  import moment from 'moment';
  import * as axios from 'axios';
  import Vue from 'vue'


  import VirtualScroll from "../../reservations/reservationListVue/src/component/VirtualScroll.vue";
  import 'vue-virtual-infinite-scroll/dist/css/vue-virtual-infinite-scroll.css'
  

  Vue.component('virtual-list', VirtualScroll)

  export default {
    name: "IncomingMessages",
    props: [],

    data() {
      return {
        selectedIncomingMsgItem: {},
        logDetailsPanel: false,
        logDetail: {},
        incomingMessages:[],
        showResourcePathList: false,
        showMethodsList:  false,
        showResponseStatusList: false,
        showIntegrationsList: false,
        selectedFilterColumn: null,
        filterResourcePathText: '',
        filterMethodText: null,
        filterResponseStatusText: null,
        filterIntegrationText: '',
        filterObj: {
          ResourcePaths: [],
          logsFilterStartDate:null,
          logsFilterEndDate:null,
          filterMethods: [],
          responseStatusFilter:[],
          integrationsFilter:[]
        },
        minDate: null,
        maxDate: null,
        logsFilterDateRange: { startDate: null, endDate: null },
        dateFormat: 'DD MMM YYYY',
        linkedCalendars: null,
        resourcePathList: [{ResourcePathName: 'postRates'}, {ResourcePathName: 'postAvailability'}, {ResourcePathName: 'postRestrictions'}, {ResourcePathName: 'createOrUpdateUnitInfo'}, {ResourcePathName: 'getReservationDetails'}, {ResourcePathName: 'postClientPMSConfirmationNumber'}],    
        methodsList: [{methodName: 'GET'},{methodName: 'POST'},{methodName: 'PUT'},],
        responseStatusList: [{statusCode: '200'},{statusCode: '201'},{statusCode: '400'},{statusCode: '500'},],
        integrationsList: [],
        // integrationsList: [{integrationName: 'Tempo'},{integrationName: 'RU'},{integrationName: 'Bookings.com'},{integrationName: 'Airbnb'},],
        items: [],
        options: {
          scrollbars: true,
          interactiveScrollbars: true,
          probeType: 3,
          mouseWheel: true,
          mouseWheelSpeed: 1
        },
        viewSaveObject: {
          filters: [],
          ResourcePaths: [],
          Methods: [],
          ResponseStatuses:[],
          IntegrationNames: []
        },
        viewAttrsChanged: false,
        variable: false,
        totalLength: null,
        pullDownTextObj: {
          trigger: 'Loading...',
          begin: 'Loading...',
          complete: 'There are no items',
          error: 'There is server error',
          refresh: 'Loading...'
        },
        loading: true,
        scrlBtns: false,
        scrllCount: 50,
        isGreyOut: false,
        toggleFilterPanel: false,
        linearProgress: false,
        pageNumber: 1,
        itemsPerPage: 20,
        indexCount: 0
      };
    },
    methods:{
      showLogDetailsPanel(eachLog){
        let vm=this;
        vm.logDetail = eachLog;
        this.logDetailsPanel = true;
        vm.selectedIncomingMsgItem = eachLog;

      },
      refreshBtnClicked() {
        let vm = this
        vm.items = [];
        vm.pageNumber = 1;
        let refreshBtnEl = document.getElementById('refreshBtn')
        refreshBtnEl.classList.add('btn-default-refresh1')

        setTimeout(() => {
          console.log('refreshBtnEl', refreshBtnEl)
          refreshBtnEl.classList.remove('btn-default-refresh1')
        }, 500)
        vm.getIncomingMessagesFnc()
      },
      getIncomingMessagesFnc() {
        console.log("getIncomingMessages is calling")
        let vm = this;

        if (vm.items.length == 0) {
          vm.loading = true;
        }
        else if (vm.items.length > 0) {
          vm.loading = false;
        }
        vm.$store.dispatch("dataRequestHandler",
            {
            key: "GetIncomingMessages",
            params: {
              ModuleAction: "GetIncomingMessages",
              PageNumber: vm.pageNumber,
              PageSize: vm.itemsPerPage,
              ResourcePath: vm.filterObj.ResourcePaths.map((each) => each.ResourcePathName).join(','),
              ResStatusCode: vm.filterObj.responseStatusFilter.map((each) => each.statusCode).join(','),
              ReqMethod: vm.filterObj.filterMethods.map((each) => each.methodName).join(','),
              // IntegrationId: null,
              IntegrationId: vm.filterObj.integrationsFilter.map((each) => each.IntegrationId).join(','),
              FromDate: vm.filterObj.logsFilterStartDate,
              ToDate: vm.filterObj.logsFilterEndDate
            },
            callback: function (err, response) {
                if (err) {
                    console.log('GetIncomingMessages error', err)
                    vm.loading = false;
                    return;
                }

                var itemsWrap = $("#tagScrollSection").width();
                var tagBtnGrp = $(".tagBtnGrp").width();
                var calcWidth = itemsWrap + 300;
                if (calcWidth >= tagBtnGrp) {
                  vm.scrlBtns = true;
                }
                else {
                  vm.scrlBtns = false;
                }

                if (response) {
                    console.log("GetIncomingMessagesRes", response[2]);
                    vm.totalLength = response[0][0].TotalRecords;
                    if (vm.integrationsList.length === 0 && vm.filterObj.integrationsFilter.length === 0){
                      vm.integrationsList = response[2];
                    }
                    // vm.integrationsList = response[2];
                    if (vm.pageNumber === 1) {
                      let i = 1
                      vm.indexCount = 0;
                      // vm.integrationsList = response[2];
                      let updateResponse = response[1].map(each => ({...each, index: i++ }))
                      vm.items.splice(0, vm.items.length, ...updateResponse);
                      console.log('vm.items', vm.items)
                      vm.$store.dispatch("toastr", {
                      type: "success",
                      header: "Success!",
                      message: "Rendered Incoming Messages Successfully!"
                    });
                    }
                    else if (vm.pageNumber > 1) {
                      vm.indexCount = vm.items.length + 1;
                      let updateResponse = response[1].map(each => ({...each, index: vm.indexCount++ }))
                      vm.items.splice(vm.items.length, 0, ...updateResponse);
                    }

                      console.log('vm.items', vm.items)

                    vm.loading = false;
                }
            }
        });
      },
      getMoreData($stateChange) {
        console.log('getMoreData is called')
        if (this.items.length >= this.totalLength) {
          $stateChange('complete')
        } else {
          setTimeout(() => {
            $stateChange('loaded')
          }, 1500)
          this.loading = false;
          this.pageNumber++;
          this.getIncomingMessagesFnc();
        }
      },
      refreshData($pullStateChange) {
        console.log('refreshData is calling');
        setTimeout(() => {
          this.items.splice(0)
          for (let i = 0; i < 50; i++) {
            this.items.push({
              text: i,
              id: i,

            })
          }
          $pullStateChange('complete')
        }, 1500)
      },
      showFilterByType(filterCol) {
        let vm = this;
        setTimeout(function () {
          vm.selectedFilterColumn = filterCol;
          if (filterCol == "resourcePath") {
            $("#resourcePathDropDown").show();
          } else if (filterCol == "method") {
            $("#methodListDropDown").show();
          } else if (filterCol == 'responseStatus'){
            $("#responseStatusListDropDown").show();
          } else if (filterCol == 'integrationName'){
            $("#integrationsListDropDown").show();
          }
        }, 10);
      },
      removeResourcePathFromFilter(resourcePathObj, event) {
        let vm = this;
        var index = vm.filterObj.ResourcePaths.indexOf(resourcePathObj);
        if (index > -1) {
          vm.filterObj.ResourcePaths.splice(index, 1);
        }
        vm.resourcePathList.push(resourcePathObj);
        if (event)
          event.stopPropagation();
      },
      removeMethodFromFilter(method, event) {
        let vm = this;
        var index = vm.filterObj.filterMethods.indexOf(method);
        if (index > -1) {
          vm.filterObj.filterMethods.splice(index, 1);
        }
        vm.methodsList.push(method);
        if (event)
          event.stopPropagation();
      },
      removeResponseStatusFromFilter(status, event) {
        let vm = this;
        var index = vm.filterObj.responseStatusFilter.indexOf(status);
        if (index > -1) {
          vm.filterObj.responseStatusFilter.splice(index, 1);
        }
        vm.responseStatusList.push(status);
        if (event)
          event.stopPropagation();
      },
      removeIntegrationFromFilter(integration, event) {
        let vm = this;
        var index = vm.filterObj.integrationsFilter.indexOf(integration);
        if (index > -1) {
          vm.filterObj.integrationsFilter.splice(index, 1);
        }
        vm.integrationsList.push(integration);
        if (event)
          event.stopPropagation();
      },
      removeSelectedlogsFilterDatesFromFilter(filterObj) {
        filterObj.logsFilterStartDate = null,
        filterObj.logsFilterEndDate = null,
        this.logsFilterDateRange.startDate = null,
        this.logsFilterDateRange.endDate = null,
        this.applyFilter();
      },
      showResourcePathFnc() {
        this.showResourcePathList = true;
      },
      showMethodsListFnc() {
        this.showMethodsList = true;
      },
      showResponseStatusListFnc() {
        this.showResponseStatusList = true;
      },
      showIntegrationsListFnc() {
        this.showIntegrationsList = true;
      },
      addResourcePathToFilter(resourcePathObj) {
        let vm = this;
        vm.filterObj.ResourcePaths.push(resourcePathObj);
        vm.filterResourcePathText = '';
        var index = vm.resourcePathList.indexOf(resourcePathObj);
        if (index > -1) {
          vm.resourcePathList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      addMethodsToFilter(methodObj) {
        let vm = this;
        vm.filterObj.filterMethods.push(methodObj);
        vm.filterMethodText = null;
        var index = vm.methodsList.indexOf(methodObj);
        if (index > -1) {
          vm.methodsList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      addResponseStatusToFilter(statusObj) {
        let vm = this;
        vm.filterObj.responseStatusFilter.push(statusObj);
        vm.filterResponseStatusText = null;
        var index = vm.responseStatusList.indexOf(statusObj);
        if (index > -1) {
          vm.responseStatusList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      addIntegrationToFilter(integrationObj) {
        let vm = this;
        vm.filterObj.integrationsFilter.push(integrationObj);
        vm.filterIntegrationText = '';
        var index = vm.integrationsList.indexOf(integrationObj);
        if (index > -1) {
          vm.integrationsList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      scrollRight: function () {
        var container = this.$el.querySelector("#tagScrollSection");
        var cnt = this.scrllCount++;
        container.scrollLeft = cnt;
        console.log("scroll counter before" + cnt);
        this.scrllCount = this.scrllCount + 50;
        console.log("scroll counter after" + cnt);
        this.scrollLeft = cnt;


      },
      scrollLeft: function () {

        var container = this.$el.querySelector(".scrollingTags");
        console.log("Inner width -" + container.clientWidth);
        if (this.scrllCount == -1) {
          var container = this.$el.querySelector("#tagScrollSection");
          container.scrollLeft = 0;
          console.log("If");
        } else {
          var container = this.$el.querySelector("#tagScrollSection");
          var cnt2 = this.scrllCount--;
          container.scrollLeft = cnt2;
          console.log("scroll counter before" + cnt2);
          this.scrllCount = this.scrllCount - 50;
          console.log("scroll counter after" + cnt2);
        }
      },
      applyFilter() {
        let vm = this;
        console.log("filterObj", vm.filterObj)
        console.log("GetIncomingMessages", new Date(this.filterObj.logsFilterStartDate), this.filterObj.logsFilterEndDate);

        vm.items = [];
        vm.pageNumber = 1;
        vm.toggleFilterPanel = false;
        vm.showResourcePathList= false
        vm.showMethodsList= false,
        vm.showResponseStatusList = false,
        vm.showIntegrationsList= false,
        vm.viewSaveObject.ResourcePaths.splice(0, vm.viewSaveObject.ResourcePaths.length, ...vm.filterObj.ResourcePaths);
        vm.viewSaveObject.Methods.splice(0, vm.viewSaveObject.Methods.length, ...vm.filterObj.filterMethods);
        vm.viewSaveObject.ResponseStatuses.splice(0, vm.viewSaveObject.ResponseStatuses.length, ...vm.filterObj.responseStatusFilter);
        vm.viewSaveObject.IntegrationNames.splice(0, vm.viewSaveObject.IntegrationNames.length, ...vm.filterObj.integrationsFilter);
        if (vm.viewSaveObject.ResourcePaths.length > 1 || vm.viewSaveObject.Methods.length > 1 || vm.viewSaveObject.ResponseStatuses.length > 1 || vm.viewSaveObject.IntegrationNames.length > 1 ) {
          vm.viewAttrsChanged = true;
        } else {
          vm.viewAttrsChanged = false;
        }
        vm.getIncomingMessagesFnc();
      },
  
      selectColumn(column, event) {
        let vm = this;
      },

      closeFilter() {
        let vm = this;
        vm.toggleFilterPanel = false;
        vm.logDetailsPanel=false
        vm.showResourcePathList= false
        vm.showMethodsList= false
        vm.showResponseStatusList=false
        vm.showIntegrationsList= false
      },

      clearAllFilters() {
        this.items = [];
        this.scrlBtns = false;
        this.viewAttrsChanged = false;
        this.showResourcePathList= false
        this.showMethodsList= false
        this.showResponseStatusList=false
        this.showIntegrationsList= false
        this.resourcePathList = [{ResourcePathName: 'postRates'}, {ResourcePathName: 'postAvailability'}, {ResourcePathName: 'postRestrictions'}, {ResourcePathName: 'createOrUpdateUnitInfo'}, {ResourcePathName: 'getReservationDetails'}, {ResourcePathName: 'postClientPMSConfirmationNumber'}];   
        this.methodsList = [{methodName: 'GET'},{methodName: 'POST'},{methodName: 'PUT'},];
        this.responseStatusList = [{statusCode: '200'},{statusCode: '201'},{statusCode: '400'},{statusCode: '500'},];
        this.filterObj = {
          ResourcePaths: [],
          logsFilterStartDate:null,
          logsFilterEndDate:null,
          filterMethods: [],
          responseStatusFilter:[],
          integrationsFilter:[],
        };

        this.viewSaveObject = {
          filters: [],
          ResourcePaths: [],
          Methods: [],
          ResponseStatuses:[],
          IntegrationNames: [],
        },
        this.pageNumber = 1;
        this.itemsPerPage = 20;
        // after clearing the filters passing the date range as current day
        this.logsFilterDateRange.startDate = new Date(); 
        this.logsFilterDateRange.endDate = new Date();

        this.getIncomingMessagesFnc();
      },
      updatelogFilterDateValues(value) {
        this.filterObj.logsFilterStartDate = moment.utc(value.startDate).format('DD MMM YYYY')
        this.filterObj.logsFilterEndDate = moment.utc(value.endDate).format('DD MMM YYYY')
      },
      deleteSelectedResourcePathFromFilter(index, resourceObj) {
        this.removeResourcePathFromFilter(resourceObj);
        this.viewSaveObject.ResourcePaths.splice(index, 1);
        this.applyFilter();
      },
      deleteSelectedMethodFromFilter(index, methodObj) {
        this.removeMethodFromFilter(methodObj);
        this.viewSaveObject.Methods.splice(index, 1);
        this.applyFilter();
      },
      deleteSelectedResponseStatusFromFilter(index, statusObj) {
        this.removeResponseStatusFromFilter(statusObj);
        this.viewSaveObject.ResponseStatuses.splice(index, 1);
        this.applyFilter();
      },
      deleteSelectedIntegrationNameFromFilter(index, methodObj) {
        this.removeIntegrationFromFilter(methodObj);
        this.viewSaveObject.IntegrationNames.splice(index, 1);
        this.applyFilter();
      },
    },
    computed: {
      filteredResourcePathList() {
        let filteredList = this.resourcePathList.filter(each => each.ResourcePathName.toLowerCase().includes(this.filterResourcePathText.toLowerCase()));
        return filteredList
      },
      filteredIntegrationNameList() {
        let filteredList = this.integrationsList.filter(each => each.IntegrationName.toLowerCase().includes(this.filterIntegrationText.toLowerCase()))
        return filteredList
      }
    },
    watch: {
      
      items(newArr, oldArr) {
        console.log("items changed", oldArr, newArr);
      },
    },
    mounted() {
      let vm =  this;
      // console.log("integrationsList", vm.integrationsList)
      vm.getIncomingMessagesFnc();
      $(this.$el).find("ul.dropdown-menu").click(function (e) {
        e.stopPropagation();
      });
      $(document).click(function (e) {
        $(".form-control.searchResultsAmenities").hide();
        vm.selectedFilterColumn = null;
      })
    },
    components: {
  
    },
    beforeDestroy() {
     
    }
  };

</script>
<style>

</style>